/** Base path for admin shell (matches React Router `/` layout). */
export const ADMIN_PORTAL_BASE = '/';

/** Relative paths under the root dashboard layout. */
export const ADMIN_ROUTES = {
  /** Tabbed profile + overview for company Admins (not Super Admin). */
  PROFILE_DASHBOARD: 'profile-dashboard',
  ACTIVITY_OVERVIEW: 'activity-overview',
  DEVICE_SESSIONS: 'device-sessions',
  USER_ACTIVITY: 'user-activity',
  DASHBOARD_PREFERENCES: 'dashboard-preferences',
  NOTIFICATIONS: 'notifications',
  HELP_SUPPORT: 'help-support',
  SUPPORT_MANAGEMENT: 'support-management',
  /** Nested paths under `/support-management/...` */
  SUPPORT_MGMT_DASHBOARD: 'support-management/dashboard',
  SUPPORT_MGMT_TICKETS: 'support-management/tickets',
  SUPPORT_MGMT_REPORTED_ISSUES: 'support-management/reported-issues',
  SUPPORT_MGMT_FAQ: 'support-management/faq-management',
  FAQ: 'faq',
  REPORT_ISSUE: 'report-issue',
  NEW_TICKET: 'new-ticket',
  DATA_USAGE_POLICY: 'data-usage-policy',
  TERMS_CONDITIONS: 'terms-conditions',
};

export function adminPath(segment) {
  const s = String(segment || '').replace(/^\//, '');
  return s ? `/${s}` : '/';
}
